/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from '@emotion/react';
import { useEffect, useRef } from 'react';
import Icon from '../Icon';

export const optionStyles = (theme, checked, xStyle = {}) => ({
	display: 'inline-block',
	'input[type="checkbox"], input[type="file"]': {
		position: 'absolute',
		opacity: 0,
		width: 1,
		height: 1,
		marginRight: -5,
	},

	label: {
		// height: '5.5rem',
		minHeight: '5.5rem',
		fontSize: '1.8rem',
		minWidth: '291px',
		// padding: '1.5rem 4rem',
		padding: '0.4rem 4rem 0.5rem',
		borderRadius: '1rem',
		transition: 'color .3s, background-color .3s, border-color .5s',
		paddingLeft: 30,
		paddingRight: 30,
		display: 'flex',
		alignItems: 'center',
		cursor: 'pointer',
		color: theme.colors.base['grey-5'],
		border: '1px solid currentColor',
		borderWidth: 1,
		[theme.breakpoints.down('md')]: {
			// padding: '1.5rem 2rem',
			padding: '0.4rem 2rem 0.5rem',
		},
		'.icon': {
			marginRight: 16,
			display: 'inline-block',
			fontSize: '133.33%',
			lineHeight: '1rem',
			'i:before': {
				verticalAlign: 'middle',
			},
		},
		'input[type="text"]': {
			appearance: 'none',
			border: 'none',
			background: 'transparent',
			fontSize: '1.8rem',
			color: 'inherited',
			borderRadius: 1,
			width: '100%',
			'&:focus': {
				outline: '2px solid #ffffff66',
				outlineOffset: 6,
			},
		},
		...(checked
			? {
					color: theme.colors.brand.main,
					backgroundColor: theme.colors.brand['light'],
					borderWidth: 2,
					fontWeight: 700,
			  }
			: {}),
	},
	'input + label:hover': {
		color: 'white',
		backgroundColor: theme.colors.brand.main,
		borderColor: 'transparent',
		'input[type="text"]': {
			color: 'white',
		},
	},
	'input:focus + label, label:focus': {
		fontWeight: 700,
		outline: '4px solid #091AE080',
		outlineOffset: 4,
	},
	...(typeof xStyle === 'function' ? xStyle(theme) : xStyle),
});

const OptionButton = ({ children = '', name, id = name, value, disabled = false, checked = false, xStyle, onChange = null, textInputProps = null, ...props }) => {
	const ref = useRef(null);
	useEffect(() => {
		ref.current?.focus();
	}, [ref, ref.current]);
	return (
		<span css={theme => optionStyles(theme, checked, xStyle)} checked={checked} {...props}>
			<input type="checkbox" checked={checked} id={id} name={name} value={value} onChange={onChange} />
			<label htmlFor={id} checked>
				{checked ? (
					<span className="icon">
						<Icon className="fi fi-br-check" />
					</span>
				) : null}
				{textInputProps && checked ? (
					<input
						ref={ref}
						autoFocus={true}
						type="text"
						id={`inputtext-${id}`}
						name={textInputProps.name}
						value={textInputProps.value}
						onChange={textInputProps.onChange}
						onBlur={textInputProps.onBlur}
					/>
				) : (
					children + (textInputProps ? textInputProps.placeholder ?? ': escrever' : '')
				)}
			</label>
		</span>
	);
};

export default OptionButton;
